function Skeleton({ className }: { className?: string }) {
  return <div className={`animate-pulse rounded-lg bg-slate-200 ${className ?? ""}`} />;
}

export function LeaveLoading({ label }: { label?: string }) {
  return (
    <div className="space-y-1" aria-label={label ?? "Loading"} role="status">
      <div className="overflow-hidden rounded-2xl border bg-white shadow-sm">
        <div className="border-b bg-slate-50 px-5 py-4">
          <Skeleton className="h-3.5 w-36" />
        </div>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="flex items-center gap-4 px-5 py-4">
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-3 w-40" />
            <Skeleton className="h-3 w-20" />
            <Skeleton className="ml-auto h-5 w-20 rounded-full" />
          </div>
        ))}
      </div>
      {label && (
        <p className="text-center text-xs text-slate-400">{label}</p>
      )}
    </div>
  );
}
